export const followupsNumberMaxSelectValue = 5;
export const defaultFollowupValue = 3;
